import { createFileRoute } from "@tanstack/react-router";

import ChallengeRulesForm from "@/components/ChallengeProfile/ChallengeRulesForm";

const Component = () => {
  const { challengeUuid } = Route.useParams();
  return <ChallengeRulesForm challengeUuid={challengeUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/challenges/$challengeUuid/profile/rules")({
  component: Component,
});
